import React from 'react'
import { Flex, Heading, Text } from '@chakra-ui/react'
import { Trans } from '@lingui/macro'
import { match, useRouteMatch } from 'react-router-dom'
import { Switch } from 'front-end/src/components'
import { useFeatureFlags } from 'front-end/src/app/hooks/useFeatureFlags'
import {
  usePatchUserMutation,
  useUserActivitySwitchQuery
} from './UserIsActiveSwitch.codegen'
import { brandColors } from 'shared/basicPalette'
import { fontSizes } from 'front-end/src/components/chakraThemeExtension'

export const UserIsActiveSwitch: React.FC<{}> = () => {
  const { params } = useRouteMatch('/user/:userId') as match<{
    userId: string
  }>
  const variables = {
    userId: Number(params.userId)
  }
  const { data, refetch } = useUserActivitySwitchQuery({
    variables
  })
  const { featureFlags } = useFeatureFlags()

  const [setActive, { loading }] = usePatchUserMutation()

  return (
    <Flex mb="12px" mt="16px" wrap="wrap">
      <Heading size="md" mr="12px" fontWeight={500}>
        <Trans>User enabled</Trans>
      </Heading>
      <Switch
        isDisabled={loading}
        isChecked={data?.admin?.user?.is_active}
        onChange={async () => {
          await setActive({
            variables: {
              ...variables,
              input: {
                is_active: !data?.admin?.user?.is_active
              }
            }
          })
          refetch()
        }}
      />
      {!data?.admin?.user?.is_active && (
        <Text
          fontSize={fontSizes.xs}
          ml="12px"
          mt={1}
          color={brandColors.grey.mid}
        >
          {featureFlags?.campaigns ? (
            <Trans>
              Beware that disabled users are ignored in campaigns and cannot log
              in!
            </Trans>
          ) : (
            <Trans>Beware that disabled users cannot log in!</Trans>
          )}
        </Text>
      )}
    </Flex>
  )
}
